<template>
  <div class="home">
    <div class="home_menu">
      <div class="menu_card" v-for="menu in menuList" :key="menu.name">
        <div class="card_name">{{ menu.name }}</div>
        <div class="card_list">
          <div
            class="list_item"
            v-for="item in menu.list"
            :key="item.name"
            @click="handleMenuItemClick(item)"
          >
            <i class="item_icon lpIconfont" :class="item.icon"></i>
            <div class="item_name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      menuList: [
        {
          name: "站点管理",
          color: "#29c19b",
          list: [
            {
              name: "小区管理",
              icon: "icon-xiaoqu-xianxing",
              page: "/CellManagement",
            },
            {
              name: "设备管理",
              icon: "icon-chongdianzhuang",
              page: "/DeviceManage",
            },
            {
              name: "设备异常",
              icon: "icon-xialingyingicon-34",
              page: "/DeviceExceptionInfo",
            },
            { name: "离线统计", icon: "icon-lixian", page: "/OffLineLog" },
          ],
        },
        {
          name: "电卡管理",
          color: "#8ebfff",
          list: [
            { name: "全部电卡", icon: "icon-card", page: "/ElectricityCardManage" },
            { name: "转移记录", icon: "icon-dingdan", page: "/ElectricityCardTransferRecords" },
          ],
        },
        {
          name: "车库管理",
          color: "#fb8f8c",
          list: [
            {
              name: "全部车库",
              icon: "icon-kucunzaishoucheliang",
              page: "/GarageManage",
            },
            {
              name: "门禁管理",
              icon: "icon-menjin",
              page: "/AccessControlDevice",
            },
          ],
        },
      ],
    };
  },
  methods: {
    // 点击菜单项时触发
    handleMenuItemClick(item) {
      if (item.page) {
        this.$router.push(item.page);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  .home_menu {
    padding: 15px;
    .menu_card {
      border-radius: 8px;
      box-shadow: 1px 1px 5px #ddd;
      margin-bottom: 10px;
      padding: 10px;
      .card_name {
        position: relative;
        font-weight: bold;
        padding-left: 8px;
        letter-spacing: 1px;
        margin-bottom: 5px;

        &::after {
          display: block;
          content: "";
          position: absolute;
          top: 10%;
          left: 0;
          width: 2px;
          height: 80%;
          background-color: #409eff;
        }
      }

      .card_list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .list_item {
          width: calc(33% - 20px);
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          margin: 10px;
          .item_icon {
            margin-bottom: 8px;
            font-size: 20px;
          }
          .item_name {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
